import { ReCaptchaProvider } from '@nosinovacao/nosid-mfe-common';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { RouterProvider } from '@tanstack/react-router';
import { env } from './env';
import { router } from './router';

const queryClient = new QueryClient();

export function App() {
  return (
    <ReCaptchaProvider reCaptchaKey={env.GoogleRecaptchaSiteKey}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} notFoundMode="root" />
      </QueryClientProvider>
    </ReCaptchaProvider>
  );
}
